var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75.66 57.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.03,57.43H.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.18,44.45H75.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.52,48.01c0,.79-.65,1.44-1.44,1.44H1.58c-.79,0-1.44-.65-1.44-1.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.13,53.01c2.06,0,1.44-1.68,1.44-2.59H.09c0,.91-.62,2.59,1.44,2.59H74.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.03,35.45H.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.18,22.48H75.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.52,26.04c0,.79-.65,1.44-1.44,1.44H1.58c-.79,0-1.44-.65-1.44-1.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.13,31.04c2.06,0,1.44-1.68,1.44-2.59H.09c0,.91-.62,2.59,1.44,2.59H74.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.03,13.47H.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.18,.5H75.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.52,4.06c0,.79-.65,1.44-1.44,1.44H1.58c-.79,0-1.44-.65-1.44-1.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.13,9.06c2.06,0,1.44-1.68,1.44-2.59H.09c0,.91-.62,2.59,1.44,2.59H74.13Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.38f10cdc8fcc39395eb311e3b650d0dc.svg";
export { ForwardRef as ReactComponent };